import React, { Component } from 'react';
import { firebaseRef } from '../firebase.js';
import { withRouter } from 'react-router-dom';
import FaClose from 'react-icons/lib/fa/close';
import Modal from 'react-modal';

class Historycomponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comment: false,
    };
    this.delete=this.delete.bind(this);
    this.comment=this.comment.bind(this);
    this.closeModal=this.closeModal.bind(this);
  }

  delete(){
    var userId = this.props.match.params.user;
    var doctor = this.props.match.params.doctor;
    var refMain = firebaseRef.database().ref('doctors/'+doctor+'/users/'+userId+'/buttons/'+this.props.id);
    refMain.remove();
  }

  comment(){
    this.setState({ comment: true });
  }

  closeModal(){
    this.setState({ comment: false });
  }

  render(){
    const {order, pArray, ocrt, main, date, comment, p1Check, mainAfter} = this.props;
        return (
                <div className="forms-container-flex history-divs">
                <Modal
                isOpen={this.state.comment}
                onRequestClose={this.closeModal}
                className="Modal"
                contentLabel="Example Modal"
                >
                <div>
                  <button type="button" style={{borderColor: 'transparent', padding: 20}} onClick={() => this.setState({ comment:false })}><FaClose /></button>
                </div>
                <div className="login-signup-container" align="center"><h3>The comment for the treatment in {date}:</h3></div>
                <div style={{margin: 10}}><h4>{comment}</h4></div>
                </Modal>
                <button type="button" className="delete-history" onClick={this.delete}>Delete</button>
                {comment === '' ? (
                  <div></div>
                ):(
                  <button type="button" className="comment-history" onClick={this.comment}>Comment</button>
                )}
                <div className="history-inner-divs main-history-inner-divs"><p><b>{`${order === "" ? '':(order + ' + ')} ${pArray === "" ? '':(pArray + ' + ')} ${main === "" ? '':(main + ' + ')} ${p1Check === "" ? '':(p1Check + ' + ')} ${ocrt === "" ? '':(ocrt + ' + ')} ${mainAfter === "" ? '':(mainAfter)}`}
                </b></p></div>
                <div className="history-inner-divs date-history"><p>{date}</p></div>
               </div>
             );


    }
  }

export default withRouter(Historycomponent);



// WEBPACK FOOTER //
// ./src/routes/Paitent/Historycomponent.js